<form id="modal-table"
      [formGroup]="form">
  <div class="modal-header">
    <h4 class="modal-title pull-left text-md"><b>{{title}}</b></h4>
    <button type="button"
            class="btn-close text-sm"
            aria-label="Close"
            (click)="bsModalRef?.hide()">
      <span aria-hidden="true"
            class="visually-hidden text-md">&times;</span>
    </button>
  </div>
  <div class="modal-body py-0">
    <div class="row">
      <!-- TYPE -->
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label class="form-label text-sm"><b>HTML Type <span class="required-field">*</span></b></label>
          <ng-select class="text-md"
                     [class.error-select]="type?.invalid && (type?.dirty || type?.touched)"
                     [items]="typeHTML"
                     [clearable]="false"
                     [virtualScroll]="true"
                     [multiple]="false"
                     [hideSelected]="true"
                     (change)="changeType($event)"
                     placeholder="Select some option"
                     dropdownPosition="bottom"
                     formControlName="type"
                     name="type"
                     id="type"
                     bindLabel="name"
                     bindValue="value">
          </ng-select>
          <div class="text-sm required-field my-1"
               *ngIf="type?.invalid && (type?.dirty || type?.touched)">
            Field required
          </div>
        </div>
      </div>

      <!-- NAME -->
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <label for="name"
               class="form-label text-sm"><b>Name <span class="required-field">*</span></b></label>
        <!-- <input type="text" (keypress)="onKeyPress($event)" placeholder="Id" class="form-control" id="id" formControlName="id"> -->
        <input type="text"
               (keypress)="onKeyPress($event)"
               placeholder="Type the name of the field"
               class="form-control"
               id="name"
               formControlName="name">
        <!-- ERROR-->
        <div class="alert-title"
             *ngIf="
              form.get('name') &&
              form.get('name').invalid &&
              (form.get('name').dirty || form.get('name').touched)
            ">
          <span class="error"
                *ngIf="form.get('name')?.errors?.required">
            Required field.
          </span>
          <span class="error"
                *ngIf="form.get('name')?.errors?.invalidSlug">
            Only letters, numbers, underscores and hyphens are allowed.
          </span>
          <span class="error"
                *ngIf="form.get('name')?.errors?.duplicateSlug">
            This name already exists in the current form.
          </span>
        </div>
      </div>

      <!-- VARIABLES NAME -->
      <div *ngIf="showVariableNames"
           class="col-12">
        <div class="mb-1">
          <label class="form-label text-sm"><b>VARIABLES NAMES</b></label>
          <input type="text"
                 placeholder="Example: name, lastName, phone ..."
                 class="form-control"
                 id="variable_names"
                 formControlName="variable_names">
        </div>
      </div>

      <!-- LABEL -->
      <div *ngIf="showLabel"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label for="label"
                 class="form-label text-sm"><b>Label </b></label>
          <input type="text"
                 placeholder="Type the title of the field"
                 class="form-control"
                 id="label"
                 formControlName="label">
          <!-- ERROR-->
          <div class="text-sm required-field my-1"
               *ngIf="label?.invalid && (label?.dirty || label?.touched)">
            Field required
          </div>
        </div>
      </div>

      <!-- PLACEHOLDER -->
      <div *ngIf="showPlaceholder"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <label for="placeholder"
               class="form-label text-sm"><b>Placerholder </b></label>
        <input type="text"
               placeholder="Type the description of the field"
               class="form-control"
               id="placeholder"
               formControlName="placeholder">
        <!-- ERROR-->
        <div class="text-sm required-field my-1"
             *ngIf="placeholder?.invalid && (placeholder?.dirty || placeholder?.touched)">
          Field required
        </div>
      </div>

      <!-- STEP -->
      <div *ngIf="showStep"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label for="step"
                 class="form-label text-sm"><b>Step</b></label>
          <input type="number"
                 placeholder="Type the step of the field"
                 formControlName="step"
                 class="form-control"
                 id="step">
        </div>
      </div>

      <!-- MIN  -->
      <div *ngIf="showMin"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label for="min"
                 class="form-label text-sm"><b>Min</b></label>
          <input type="number"
                 placeholder="Type the min value of the field"
                 formControlName="min"
                 class="form-control"
                 id="min">
        </div>
      </div>

      <!-- MAX -->
      <div *ngIf="showMax"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label for="max"
                 class="form-label text-sm"><b>Max</b></label>
          <input type="number"
                 placeholder="Type the max value of the field"
                 formControlName="max"
                 class="form-control"
                 id="max">
        </div>
      </div>

      <!-- HELP TEXT -->
      <div *ngIf="showHelpText"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label for="help_text"
                 class="form-label text-sm"><b>Text Help</b></label>
          <input type="text"
                 placeholder="Type the help text of the field"
                 formControlName="help_text"
                 class="form-control"
                 id="help_text">
        </div>
      </div>

      <!-- SEARCH -->
      <div *ngIf="showSearch">
        <div class="row">
          <label class="text-md"><b>Mango Cache Options</b></label>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <div class="mb-1">
              <label for="search_url"
                     class="form-label text-sm"><b>Url</b></label>
              <input type="text"
                     placeholder="Type or paste the url to search"
                     formControlName="search_url"
                     class="form-control"
                     id="search_url">
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <div class="mb-1">
              <label for="search_headers"
                     class="form-label text-sm"><b>Headers</b></label>
              <textarea type="text"
                     placeholder=""
                     formControlName="search_headers"
                     class="form-control"
                     id="search_headers" rows="5"></textarea>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <div class="mb-1">
              <label for="search_query_param"
                     class="form-label text-sm"><b>Queryparam Name</b></label>
              <input type="text"
                     placeholder="Type name of queryparam to use in search"
                     formControlName="search_query_param"
                     class="form-control"
                     id="search_query_param">
            </div>
          </div>

          <!-- SEARCH OPTION -->
          <div class="col-12">
            <div [formGroup]=formSearchOptions>
              <div class="row">
                <label class="text-md"><b>Typeahead Options</b></label>
                <!-- VALUE -->
                <div class="col-4">
                  <div class="mb-1">
                    <label for="option_search_value"
                           class="form-label text-sm"><b>Value</b></label>
                    <input type="text"
                           placeholder="Value"
                           formControlName="value_option"
                           class="form-control"
                           id="option_search_value">
                    <label *ngIf="formSearchOptions.errors?.equalValue"
                           class="text-sm required-field my-1">
                      That element already exists
                    </label>
                  </div>
                </div>

                <!-- LABEL -->
                <div class="col-4">
                  <div class="mb-1">
                    <label for="option_search_label"
                           class="form-label text-sm"><b>Label</b></label>
                    <input type="text"
                           placeholder="Label"
                           formControlName="label_option"
                           class="form-control"
                           id="option_search_label">
                  </div>
                </div>

                <!-- BUTTON ADD -->
                <div class="col-4 d-flex align-items-end pb-1">
                  <button type="button"
                          class="btn-add text-sm"
                          (click)="newSearchOption(formSearchOptions.value)">
                    <span class="material-symbols-outlined icon-option-add">
                      add
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <!-- LIST -->
            <div class="d-flex flex-wrap">
              <div *ngFor="let elem of selectedSearchOptions; let index = index"
                   class="options-selected">
                <label> {{elem.value_option}} </label>
                <label class="mx-1"> | </label>
                <label class="me-1"> {{elem.label_option}} </label>
                <span class="material-symbols-outlined icon-option-delete"
                      (click)="deleteSearchOption(index)">
                  close
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- DATE -->
      <div *ngIf="showDate">
        <div class="row">
          <label class="text-md"><b>Date Options</b></label>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <div class="mb-1">
              <label for="step"
                     class="form-label text-sm"><b>Min Days Before Today</b></label>
              <input type="number"
                     placeholder="Enter number of days to be active before today"
                     formControlName="min_days_before_today"
                     class="form-control"
                     id="min_days_before_today">
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <div class="mb-1">
              <label for="step"
                     class="form-label text-sm"><b>Min Days After Today</b></label>
              <input type="number"
                     placeholder="Enter number of days to be active after today"
                     formControlName="min_days_after_today"
                     class="form-control"
                     id="min_days_after_today">
            </div>
          </div>

        </div>
      </div>

      <!-- TEXT -->
      <div *ngIf="showText"
           class="col-12">
        <div class="mb-1">
          <label class="form-label text-sm"><b>Text </b></label>
          <editor [init]="{
              base_url: '/tinymce',
              suffix: '.min',
              height:250,
              promotion: false,
              menubar: false,
              toolbar: 'undo redo styles bold italic alignleft aligncenter alignright alignjustify | bullist numlist outdent indent| code',
              plugins: ['code'],
            }"
                  formControlName="text">
          </editor>
        </div>
      </div>

       <!-- MULTI UPLOADER CONCURRENT  -->
      <div *ngIf="showMultiUploaderConcurrent"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label for="concurrent_uploads_multi"
                 class="form-label text-sm"><b>Concurrent Uploads</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="If blank default value is 3 concurrent uploads.">
            help
          </span>
          <input type="number"
                 placeholder="How many concurrent uploads are allowed"
                 formControlName="concurrent_uploads_multi"
                 class="form-control"
                 id="concurrent_uploads_multi">
        </div>
      </div>

        <!-- MULTI UPLOADER MAX FILES  -->
      <div *ngIf="showMultiUploaderMaxFiles"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label for="max_files_uploads_multi"
                 class="form-label text-sm"><b>Max Files Uploads</b></label>
                 <span class="mx-1 material-symbols-outlined icon-help"
                       tooltip="If blank default value is 5 maximum files uploads.">
                   help 
                  </span>
          <input type="number"
                 placeholder="Maximum number of files that can be uploaded"
                 formControlName="max_files_uploads_multi"
                 class="form-control"
                 id="max_files_uploads_multi">
        </div>
      </div>

        <!-- MULTI UPLOADER TYPE FILES  -->
      <div *ngIf="showMultiUploaderTypeFiles"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label for="type_files_uploads_multi"
                 class="form-label text-sm"><b>Allowed File Types</b></label>
                 <span
  class="mx-1 material-symbols-outlined icon-help"
  tooltip="
Use comma-separated values.
Examples:
• image/*
• application/pdf
• .pdf,.doc,.docx
• image/*,application/pdf
Leave blank = image/* only
"
>
  help
</span>
          <input type="text"
                 placeholder="See help for more information about allowed file types"
                 formControlName="type_files_uploads_multi"
                 class="form-control"
                 id="type_files_uploads_multi">
        </div>
      </div>

        <!-- MULTI UPLOADER MAX SIZE  -->
      <div *ngIf="showMultiUploaderMaxSize"
           class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <div class="mb-1">
          <label for="max_size_uploads_multi"
                 class="form-label text-sm"><b>Max Size Uploads (MB)</b></label>
                  <span class="mx-1 material-symbols-outlined icon-help"
                        tooltip="If blank default value is 10 MB maximum size per file.">
                    help 
                    </span>
          <input type="number"
                 placeholder="Maximum size in MB of uploaded files"
                 formControlName="max_size_uploads_multi"
                 class="form-control"
                 id="max_size_uploads_multi">
        </div>
      </div>

      <!-- OPTION -->
      <div *ngIf="showOptions"
           class="col-12">
        <div class="row mt-2 mb-2"><label class="text-md"><b>Options</b></label></div>

        <div class="row" >
          <div *ngIf="showOptionsCache" class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
            <div class="mb-1 d-flex align-items-center">
              <input formControlName="options_cache"
                     type="checkbox"
                     class="form-check-input"
                     id="options_cache">
              <label class="form-check-label text-sm pointer"
                     for="options_cache"><b>Use Mango Cache</b></label>
              <span class="mx-1 material-symbols-outlined icon-help"
                    tooltip="Use Mango Cache to pull field content.">
                help
              </span>
            </div>
          </div>

          <div *ngIf="selectedType !== 'select-flat-tree'" class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
            <div class="mb-1 d-flex align-items-center">
              <input formControlName="options_object"
                     type="checkbox"
                     class="form-check-input"
                     id="options_object">
              <label class="form-check-label text-sm pointer"
                     for="options_object"><b>Use Entire Object</b></label>
              <span class="mx-1 material-symbols-outlined icon-help"
                    tooltip="The entire JSON object will be saved, it includes key and value.">
                help
              </span>
            </div>
          </div>

          <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3"
               *ngIf="form.get('type')?.value === 'tree-select'">
            <div class="mb-1 d-flex align-items-center">
              <input formControlName="multi_select"
                     type="checkbox"
                     class="form-check-input"
                     id="multi_select">
              <label class="form-check-label text-sm pointer"
                     for="multi_select"><b>Multi-Select</b></label>
              <span class="mx-1 material-symbols-outlined icon-help"
                    tooltip="Allow selection of multiple items in cascade (tree-select only).">
                help
              </span>
            </div>
          </div>

        </div>

        <!-- FLAT TREE OPTIONS-->
           <div class="row"
               *ngIf="!form.get('options_cache')?.value && selectedType === 'select-flat-tree'">
               <div class="col-12">
                <div class="alert alert-info text-sm mt-2">
                  <span class="material-symbols-outlined" style="font-size:16px; vertical-align:middle;">info</span>
                  Build a tree like: <b>father/son/grandson</b>. Saved as a tree object; the field renders it as flat options.
                </div>
              </div>

            <!-- Input to add path -->
            <div class="col-12 col-md-8">
              <div class="mb-1">
                <label class="form-label text-sm"><b>Path</b></label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Example: father/son/grandson"
                  formControlName="flat_tree_path"
                  id="flat_tree_path"
                />

                <div class="text-sm required-field my-1" *ngIf="flatTreePathInvalid">
                  Path required (use / to separate levels).
                </div>

                <div class="text-sm required-field my-1" *ngIf="form.errors?.flatTreeDuplicate">
                  That path already exists.
                </div>
              </div>
            </div>

            <!-- Add button -->
            <div class="col-12 col-md-4 d-flex align-items-end pb-1">
              <button type="button" class="btn-add text-sm" (click)="addFlatTreePath()">
                <span class="material-symbols-outlined icon-option-add">add</span>
                Add path
              </button>
            </div>

            <!-- Preview list (flat) -->
            <div class="col-12 mt-2" *ngIf="flatTreePreview.length">
              <label class="text-md"><b>Flat preview</b></label>

              <div class="d-flex flex-wrap mt-2 mb-2">
                <div *ngFor="let p of flatTreePreview; let i = index" class="options-selected">
                  <label>{{ p }}</label>
                  <span class="material-symbols-outlined icon-option-delete"
                        (click)="deleteFlatTreePath(i)">
                    close
                  </span>
                </div>
              </div>
            </div>

            <!-- Optional: show current JSON being saved -->
            <div class="col-12 mt-2" *ngIf="flatTreeObject && flatTreePreview.length">
              <label class="text-md"><b>Saved tree (options)</b></label>
              <pre class="text-sm"
                  style="background:#f8f9fa;border:1px solid #dee2e6;border-radius:4px;padding:8px;max-height:240px;overflow:auto;">
        {{ flatTreeObject | json }}
              </pre>
            </div>
           </div>

        <div [formGroup]=formOptions>          

          <!-- STANDARD OPTIONS-->
          <div class="row"
               *ngIf="!form.get('options_cache')?.value && selectedType !== 'select-flat-tree'">
            <!-- VALUE -->
            <div class="col-4">
              <div class="mb-1">
                <label for="option_value"
                       class="form-label text-sm"><b>Value</b></label>
                <!-- <input type="text"
                       placeholder="Value"
                       formControlName="value_option"
                       class="form-control text-lowercase"
                       id="option_value"> -->
                <input type="text"
                       placeholder="Value"
                       formControlName="value_option"
                       class="form-control"
                       id="option_value">
                <label *ngIf="formOptions.errors?.equalValue"
                       class="text-sm required-field my-1">
                  That element already exists
                </label>
              </div>
            </div>

            <!-- LABEL -->
            <div class="col-4">
              <div class="mb-1">
                <label for="option_label"
                       class="form-label text-sm"><b>Label</b></label>
                <input type="text"
                       placeholder="Label"
                       formControlName="label_option"
                       class="form-control"
                       id="option_label">
              </div>
            </div>

            <!-- BUTTON ADD -->
            <div class="col-4 d-flex align-items-end pb-1">
              <button type="button"
                      class="btn-add text-sm"
                      (click)="newOption(formOptions.value)">
                <span class="material-symbols-outlined icon-option-add">
                  add
                </span>
              </button>
            </div>

            <!-- LIST -->
            <div class="d-flex flex-wrap mt-2 mb-2">
              <div *ngFor="let elem of selectedOptions; let index = index"
                   class="options-selected">
                <label> {{elem.value_option}} </label>
                <label class="mx-1"> | </label>
                <label class="me-1"> {{elem.label_option}} </label>
                <span class="material-symbols-outlined icon-option-delete"
                      (click)="deleteOption(index)">
                  close
                </span>
              </div>
            </div>

          </div>         
        

        </div>

        <!-- MANGO CACHE OPTIONS-->
        <div class="row"
             *ngIf="form.get('options_cache')?.value && showOptionsCache">
          <label class="text-md"><b>Mango Cache Options</b></label>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <div class="mb-1">
              <label for="step"
                     class="form-label text-sm"><b>Url</b></label>
              <input type="text"
                     placeholder="Type or paste the url to search data"
                     formControlName="options_url"
                     class="form-control"
                     id="options_url">
            </div>
          </div>
         

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <div class="mb-1">
              <label for="options_headers"
                     class="form-label text-sm"><b>Headers</b></label>
              <textarea type="text"
                     placeholder=""
                     formControlName="options_headers"
                     class="form-control"
                     id="options_headers" rows="5"></textarea>
            </div>
          </div>

          <div *ngIf="selectedType !== 'select-flat-tree'" class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            
            <div class="mb-1">
              <label for="options_key"
                     class="form-label text-sm"><b>Key Mapping</b></label>
              <input type="text"
                     placeholder="Type or paste key mapping index"
                     formControlName="options_key"
                     class="form-control"
                     id="options_key">
            </div>
            
            <div class="mb-1">
              <label for="options_value"
                     class="form-label text-sm"><b>Value Mapping</b></label>
              <input type="text"
                     placeholder="Type or paste value mapping index"
                     formControlName="options_value"
                     class="form-control"
                     id="options_value">
            </div>
          </div>

        </div>

      </div>

      <!-- CASCADE OPTIONS (Dropdown Cascade) -->
      <div *ngIf="showCascadeOptions"
           class="col-12">

        <div class="row mt-2 mb-2"><label class="text-md"><b>Cascade Options</b></label></div>

        <div class="row">
          <div *ngIf="showOptionsCache" class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
            <div class="mb-1 d-flex align-items-center">
              <input formControlName="options_cache"
                     type="checkbox"
                     class="form-check-input"
                     id="cascade_options_cache">
              <label class="form-check-label text-sm pointer"
                     for="cascade_options_cache"><b>Use Mango Cache</b></label>
              <span class="mx-1 material-symbols-outlined icon-help"
                    tooltip="Use Mango Cache to pull field content.">
                help
              </span>
            </div>
          </div>

          <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
            <div class="mb-1 d-flex align-items-center">
              <input formControlName="options_object"
                     type="checkbox"
                     class="form-check-input"
                     id="cascade_options_object">
              <label class="form-check-label text-sm pointer"
                     for="cascade_options_object"><b>Use Entire Object</b></label>
              <span class="mx-1 material-symbols-outlined icon-help"
                    tooltip="The entire JSON object will be saved, it includes key and value.">
                help
              </span>
            </div>
          </div>

          <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3"
               *ngIf="form.get('type')?.value === 'tree-select'">
            <div class="mb-1 d-flex align-items-center">
              <input formControlName="multi_select"
                     type="checkbox"
                     class="form-check-input"
                     id="cascade_multi_select">
              <label class="form-check-label text-sm pointer"
                     for="cascade_multi_select"><b>Multi-Select</b></label>
              <span class="mx-1 material-symbols-outlined icon-help"
                    tooltip="Allow selection of multiple items in cascade.">
                help
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="!form.get('options_cache')?.value">

          <div class="row mt-3 mb-2" *ngIf="showCascadeLabels">
            <div class="col-12">
              <label class="text-md"><b>Level Labels</b></label>
              <div class="alert alert-info text-sm mt-2">
                <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">info</span>
                Define the label for each dropdown level (e.g., Country, City, Locality).
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showCascadeLabels">
            <div [formGroup]="formLevelLabels">
              <div class="row">
                <div class="col-8">
                  <div class="mb-1">
                    <label for="level_label" class="form-label text-sm"><b>Label</b></label>
                    <input type="text"
                           placeholder="Level label"
                           formControlName="label_level"
                           class="form-control"
                           id="level_label">
                  </div>
                </div>
                <div class="col-4 d-flex align-items-end pb-1">
                  <button type="button"
                          class="btn-add text-sm"
                          (click)="addLevelLabel()">
                    <span class="material-symbols-outlined icon-option-add">add</span>
                  </button>
                </div>
              </div>
            </div>

            <div class="d-flex flex-wrap mt-2 mb-2">
              <div *ngFor="let levelLabel of levelLabels; let index = index"
                   class="options-selected">
                <label>{{ levelLabel }}</label>
                <span class="material-symbols-outlined icon-option-delete"
                      (click)="deleteLevelLabel(index)">
                  close
                </span>
              </div>
            </div>
          </div>
          
          <div class="row mt-3 mb-2">
            <div class="col-12">
              <label class="text-md"><b>Nested Options (Tree)</b></label>
              <div class="alert alert-info text-sm mt-2">
                <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">info</span>
                Add options hierarchically. You can create child options within each option.
              </div>
            </div>
          </div>

          <!-- Breadcrumb - Current Path -->
          <div class="row mb-2" *ngIf="!isAtRootLevel()">
            <div class="col-12">
              <div class="d-flex align-items-center p-2" style="background-color: #f8f9fa; border-radius: 4px;">
                <span class="material-symbols-outlined me-2" style="font-size: 18px;">folder_open</span>
                <span class="text-sm"><b>Current location:</b> {{ getCurrentPathLabel() }}</span>
                <button type="button" 
                        class="btn btn-sm btn-outline-secondary ms-auto"
                        (click)="navigateToParent()"
                        style="font-size: 12px;">
                  <span class="material-symbols-outlined" style="font-size: 16px;">arrow_upward</span>
                  Go up level
                </button>
              </div>
            </div>
          </div>

          <div [formGroup]="formOptions">
            <div class="row">
              <!-- VALUE -->
              <div class="col-4">
                <div class="mb-1">
                  <label for="cascade_value" class="form-label text-sm"><b>Value</b></label>
                  <input type="text"
                         placeholder="Value"
                         formControlName="value_option"
                         class="form-control"
                         id="cascade_value">
                </div>
              </div>

              <!-- LABEL -->
              <div class="col-4">
                <div class="mb-1">
                  <label for="cascade_label" class="form-label text-sm"><b>Label</b></label>
                  <input type="text"
                         placeholder="Label"
                         formControlName="label_option"
                         class="form-control"
                         id="cascade_label">
                </div>
              </div>

              <!-- BUTTON ADD -->
              <div class="col-4 d-flex align-items-end pb-1">
                <button type="button"
                        class="btn-add text-sm"
                        [disabled]="!canAddOption()"
                        (click)="addCascadeOption()">
                  <span class="material-symbols-outlined icon-option-add">add</span>
                  {{ getAddButtonLabel() }}
                </button>
              </div>
            </div>
          </div>

          <!-- LIST - Cascade Options Tree -->
          <div class="row mt-3">
            <div class="col-12">
              <div class="cascade-options-tree">
                <div *ngFor="let option of getCurrentLevelOptions(); let i = index" 
                     class="cascade-option-item mb-2 p-2"
                     style="border: 1px solid #dee2e6; border-radius: 4px; background-color: #fff;">
                  
                  <div class="d-flex align-items-center">
                    <!-- Icon -->
                    <span class="material-symbols-outlined me-2" 
                          style="font-size: 20px; color: #0d6efd;">
                      {{ hasChildren(option) ? 'folder' : 'description' }}
                    </span>
                    
                    <!-- Option Info -->
                    <div class="flex-grow-1">
                      <div class="text-sm">
                        <b>{{ option.label_option }}</b>
                        <span class="text-muted ms-2">({{ option.value_option }})</span>
                      </div>
                      <div class="text-xs text-muted" *ngIf="hasChildren(option)">
                        {{ getChildrenCount(option) }} child(ren)
                      </div>
                    </div>

                    <!-- Actions -->
                    <div class="d-flex gap-1">
                      <!-- Navigate to children -->
                      <button type="button"
                              class="btn btn-sm btn-outline-primary"
                              (click)="navigateToChildren(getChildPath(i))"
                              style="font-size: 11px; padding: 2px 8px;"
                              title="View/add children">
                        <span class="material-symbols-outlined" style="font-size: 14px;">subdirectory_arrow_right</span>
                      </button>
                      
                      <!-- Delete -->
                      <button type="button"
                              class="btn btn-sm btn-outline-danger"
                              (click)="deleteCascadeOption(i)"
                              style="font-size: 11px; padding: 2px 8px;"
                              title="Delete">
                        <span class="material-symbols-outlined" style="font-size: 14px;">delete</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Empty State -->
                <div *ngIf="getCurrentLevelEmpty()" 
                     class="text-center p-4 text-muted">
                  <span class="material-symbols-outlined" style="font-size: 48px; opacity: 0.3;">inbox</span>
                  <div class="text-sm mt-2">
                    {{ getEmptyMessage() }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary -->
          <div class="row mt-3" *ngIf="hasRootOptions()">
            <div class="col-12">
              <div class="alert alert-success text-sm">
                <b>Total root options:</b> {{ cascadeOptions.length }}
              </div>
            </div>
          </div>

        </div>

        <!-- MANGO CACHE OPTIONS FOR CASCADE-->
        <div class="row"
             *ngIf="form.get('options_cache')?.value && showOptionsCache">
          <label class="text-md"><b>Mango Cache Options</b></label>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <div class="mb-1">
              <label for="step"
                     class="form-label text-sm"><b>Url</b></label>
              <input type="text"
                     placeholder="Type or paste the url to search data"
                     formControlName="options_url"
                     class="form-control"
                     id="options_url">
            </div>
          </div>
         

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <div class="mb-1">
              <label for="options_headers"
                     class="form-label text-sm"><b>Headers</b></label>
              <textarea type="text"
                     placeholder=""
                     formControlName="options_headers"
                     class="form-control"
                     id="options_headers" rows="5"></textarea>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            
            <div class="mb-1">
              <label for="options_key"
                     class="form-label text-sm"><b>Key Mapping</b></label>
              <input type="text"
                     placeholder="Type or paste key mapping index"
                     formControlName="options_key"
                     class="form-control"
                     id="options_key">
            </div>
            
            <div class="mb-1">
              <label for="options_value"
                     class="form-label text-sm"><b>Value Mapping</b></label>
              <input type="text"
                     placeholder="Type or paste value mapping index"
                     formControlName="options_value"
                     class="form-control"
                     id="options_value">
            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="row">
      <!-- HEADER -->
      <div *ngIf="showSettings"
           class="col-12 mt-1">
        <h4 class=" text-md"><b>Field Settings</b></h4>
      </div>

      <!-- ENCRYPTED -->
      <div *ngIf="showEncrypted"
           class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
        <div class="mb-1 d-flex align-items-center">
          <input formControlName="encrypted"
                 type="checkbox"
                 class="form-check-input"
                 id="encrypted">
          <label class="form-check-label text-sm pointer"
                 for="encrypted"><b>Encrypted</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="Vivamus sagittis lacus.">
            help
          </span>
        </div>
      </div>

      <!-- REQUIRED -->
      <div *ngIf="showRequired"
           class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
        <div class="mb-1 d-flex align-items-center">
          <input formControlName="required"
                 type="checkbox"
                 class="form-check-input"
                 id="required">
          <label class="form-check-label text-sm pointer"
                 for="required"><b>Required</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="Vivamus sagittis lacus.">
            help
          </span>
        </div>
      </div>

      <!-- IMMUTABLE -->
      <div *ngIf="showInmutable"
           class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
        <div class="mb-1 d-flex align-items-center">
          <input formControlName="inmutable"
                 type="checkbox"
                 class="form-check-input"
                 id="immutable">
          <label class="form-check-label text-sm pointer"
                 for="immutable"><b>Immutable</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="Vivamus sagittis lacus.">
            help
          </span>
        </div>
      </div>

      <!-- LOCKED -->
      <div *ngIf="showLocked"
           class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
        <div class="mb-1 d-flex align-items-center">
          <input formControlName="locked"
                 type="checkbox"
                 class="form-check-input"
                 id="locked">
          <label class="form-check-label text-sm pointer"
                 for="locked"><b>Locked</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="Vivamus sagittis lacus.">
            help
          </span>
        </div>
      </div>

      <!-- VARIABLE -->
      <div *ngIf="showVariable"
           class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
        <div class="mb-1 d-flex align-items-center">
          <input formControlName="variable"
                 type="checkbox"
                 class="form-check-input"
                 id="variable">
          <label class="form-check-label text-sm pointer"
                 for="variable"><b>Variable</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="Vivamus sagittis lacus.">
            help
          </span>
        </div>
      </div>

      <!-- Indexable -->
      <div *ngIf="showIndexable"
           class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
        <div class="mb-1 d-flex align-items-center">
          <input formControlName="indexable"
                 type="checkbox"
                 class="form-check-input"
                 id="indexable">
          <label class="form-check-label text-sm pointer"
                 for="indexable"><b>Indexable</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="Vivamus sagittis lacus.">
            help
          </span>
        </div>
      </div>

      <!-- Validate -->
      <div *ngIf="showValidate"
           class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
        <div class="mb-1 d-flex align-items-center">
          <input formControlName="validate"
                 type="checkbox"
                 class="form-check-input"
                 id="validate">
          <label class="form-check-label text-sm pointer"
                 for="validate"><b>Validate</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="Vivamus sagittis lacus.">
            help
          </span>
        </div>
      </div>

      <!-- Hidden -->
      <div *ngIf="showHidden"
           class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
        <div class="mb-1 d-flex align-items-center">
          <input formControlName="hidden"
                 type="checkbox"
                 class="form-check-input"
                 id="hidden">
          <label class="form-check-label text-sm pointer"
                 for="hidden"><b>Hidden</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="Vivamus sagittis lacus.">
            help
          </span>
        </div>
      </div>

      <!-- Clear when hidden -->
      <div *ngIf="showSettings"
           class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
        <div class="mb-1 d-flex align-items-center">
          <input formControlName="clear_when_hidden"
                 type="checkbox"
                 class="form-check-input"
                 id="clear_when_hidden">
          <label class="form-check-label text-sm pointer"
                 for="clear_when_hidden"><b>Clear when hidden</b></label>
          <span class="mx-1 material-symbols-outlined icon-help"
                tooltip="Send an empty value when the Visible when condition hides the field.">
            help
          </span>
        </div>
      </div>

      <!-- Visible when -->
      <div *ngIf="showSettings"
           class="col-12 mt-2">
        <div class="d-flex align-items-center justify-content-between mb-1">
          <label class="form-label text-sm mb-0"><b>Visible when</b></label>
          <div class="d-flex align-items-center">
            <input type="checkbox"
                   class="form-check-input"
                   id="vw_advanced"
                   [checked]="vwAdvanced"
                   (change)="toggleVwAdvanced()">
            <label class="form-check-label text-sm pointer ms-1"
                   for="vw_advanced">Advanced (JSON)</label>
          </div>
        </div>

        <!-- simple editor -->
        <ng-container *ngIf="!vwAdvanced">
          <div *ngIf="vwRules.length > 1"
               class="mb-1 text-sm d-flex align-items-center">
            <span>Show when</span>
            <ng-select class="text-md vw-join mx-1"
                       [items]="vwJoinOptions"
                       bindLabel="label"
                       bindValue="value"
                       [clearable]="false"
                       [searchable]="false"
                       [(ngModel)]="vwJoin"
                       [ngModelOptions]="{standalone: true}"
                       (change)="syncVisibleWhen()"></ng-select>
            <span>of these conditions pass</span>
          </div>
          <div *ngFor="let rule of vwRules; let i = index"
               class="row g-2 mb-1 align-items-center">
            <div class="col-4">
              <ng-select class="text-md"
                         [items]="vwFieldList"
                         bindLabel="label"
                         bindValue="name"
                         placeholder="Field"
                         [clearable]="false"
                         dropdownPosition="bottom"
                         [(ngModel)]="rule.field"
                         [ngModelOptions]="{standalone: true}"
                         (change)="onVwFieldChange(rule)"></ng-select>
            </div>
            <div class="col-3">
              <ng-select class="text-md"
                         [items]="vwOperators"
                         bindLabel="label"
                         bindValue="value"
                         [clearable]="false"
                         [searchable]="false"
                         dropdownPosition="bottom"
                         [(ngModel)]="rule.op"
                         [ngModelOptions]="{standalone: true}"
                         (change)="syncVisibleWhen()"></ng-select>
            </div>
            <div class="col-4"
                 [ngSwitch]="vwValueInput(rule)">
              <ng-select *ngSwitchCase="'options'"
                         class="text-md"
                         [items]="vwOptions(rule.field)"
                         bindLabel="label_option"
                         bindValue="value_option"
                         [multiple]="true"
                         placeholder="Values"
                         dropdownPosition="bottom"
                         [(ngModel)]="rule.values"
                         [ngModelOptions]="{standalone: true}"
                         (change)="syncVisibleWhen()"></ng-select>
              <input *ngSwitchCase="'text'"
                     type="text"
                     class="form-control"
                     [placeholder]="rule.op === 'match' ? 'Text to find' : 'value1, value2'"
                     [title]="rule.text"
                     [(ngModel)]="rule.text"
                     [ngModelOptions]="{standalone: true}"
                     (ngModelChange)="syncVisibleWhen()">
            </div>
            <div class="col-1 d-flex align-items-center">
              <span class="material-symbols-outlined icon-option-delete vw-delete"
                    title="Remove condition"
                    (click)="removeVwRule(i)">delete</span>
            </div>
          </div>
          <div class="d-flex align-items-center mt-1">
            <button type="button"
                    class="btn-add text-sm px-2"
                    (click)="addVwRule()">
              <span class="material-symbols-outlined icon-option-add">add</span>
              Condition
            </button>
            <small *ngIf="!vwRules.length"
                   class="text-muted ms-2">No conditions: always visible.</small>
          </div>
        </ng-container>

        <!-- advanced editor -->
        <ng-container *ngIf="vwAdvanced">
          <textarea formControlName="visible_when"
                    class="form-control"
                    [class.is-invalid]="visible_when?.invalid"
                    id="visible_when"
                    rows="5"
                    placeholder='Empty = always visible. Example: {"field": "tipo_informe", "in": ["ecografico"]}'></textarea>
          <div *ngIf="visible_when?.invalid"
               class="invalid-feedback">Invalid JSON. It must be an object.</div>
          <small class="text-muted">Operators: in, not_in, empty, not_empty, match. Group with all / any.</small>
        </ng-container>
        <div *ngIf="vwError"
             class="text-danger text-sm mt-1">{{ vwError }}</div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn-cancel text-sm"
            data-bs-dismiss="modal"
            (click)="cancel()">Cancel</button>
    <button [disabled]="!this.form.valid"
            *ngIf="update"
            type="button"
            class="btn-save text-sm"
            data-bs-dismiss="modal"
            (click)="save(form.value)">Save</button>
    <button [disabled]="!this.form.valid"
            *ngIf="!update"
            type="button"
            class="btn-save text-sm"
            data-bs-dismiss="modal"
            (click)="save(form.value)">Add</button>
  </div>
</form>